import React from "react";
import Meta from "../../components/Meta";
import { Auth } from "aws-amplify";
import { useState, useEffect } from "react";
import ApiKeyField from "../../components/create/ApiKeyField";
import { withAuthenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css"; 
import "tippy.js/dist/tippy.css"; 
import { useRouter } from "next/router";
import { BeatLoader } from "react-spinners";

const Account = () => {
  const [userEmail, setUserEmail] = useState(null);
  const [userAPIkey, setUserAPIkey] = useState(null);
  const [activeSub, setActiveSub] = useState(null);
  const [activeSubText, setActiveSubText] = useState("Retrieving..");
  const [disableUnsub, setDisableUnsub] = useState(false);
  const router = useRouter();

  useEffect(() => {
    async function loadUserInfo() {
      try {
        Auth.currentUserInfo().then((user) => {
          if(user.attributes){
            setUserEmail(user.attributes["email"])
            setUserAPIkey(user.attributes["custom:api-key"])
          }
        });
      } catch (error) {
        console.error(error);
      }
    }

    loadUserInfo();
    isSubscribed();
  }, []);

  useEffect(() => {

    if(activeSub === true){
      setActiveSubText("Active");
    }
    else if(activeSub === false){
      setActiveSubText("Inactive");
    }

 
  }, [activeSub]);

  const isSubscribed = async () => {
    
    try {
      const user = await Auth.currentUserInfo()
      let local_apiKey = null;

      if(user.attributes){
        local_apiKey = user.attributes["custom:api-key"];
      }
      else{
        throw new Error("Failed to fetch api key!");
      }
      // fix this later

      const response = await fetch(
        "https://8ipsir5iub.execute-api.us-east-1.amazonaws.com/prod/sdapi/v1/subscribed",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": local_apiKey,

          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to check if subscribed!");
      }

      const data = await response.json();
      
      setActiveSub(data.isSubscribed);

    } catch (error) {
      console.log("[SUBSCRIBE] [1] SOMETHING WENT WRONG: ", error);
    }
  };

  const handleUnsub = async () => {
    setDisableUnsub(true);
        
    try {
      const user = await Auth.currentUserInfo();
      let local_apiKey = null;

      if(user.attributes){
        local_apiKey = user.attributes["custom:api-key"];
      }
      else{
        throw new Error("Failed to fetch api key!");
      }
      // fix this later

      const response = await fetch(
        "https://qrfvpgmg14.execute-api.us-east-1.amazonaws.com/prod/create-portal-session",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "pelgine-api-key": local_apiKey,

          },
        }
      );

      if (!response.ok) {
        throw new Error(response.status);
      }

      const link = await response.json();
 
      if(link){
        router.push(link);
      }

    } catch (error) {
      console.log("[UNSUBSCRIBE] [1] SOMETHING WENT WRONG: ", error);
      setDisableUnsub(false);
    }

  };


  return (
    <>
      <Meta title="Account Information" />
      <div className = "bg-grey dark:bg-jacarta-800 pt-[5.5rem] lg:pt-24">
        <div class="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
            <div className="px-4 sm:px-0 ">
              <h3 className="text-base font-semibold leading-7 text-gray-900">Account Information</h3>
            </div>
            <div className="mt-6 border-t border-gray-100">
              <dl className="divide-y divide-gray-100">
                <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                  <dt className="text-sm font-medium leading-6 text-gray-900 select-none">Email address</dt>
                  <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0 select-none">{userEmail}</dd>
                </div>
                <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                  <dt className="text-sm font-medium leading-6 text-gray-900 select-none">API key</dt>
                  <ApiKeyField apiKey={userAPIkey} />
                </div>
                <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                  <dt className="text-sm font-medium leading-6 text-gray-900 select-none">Subscription</dt>
                  <div className = "sm:grid sm:grid-cols-2" >
                    <div>
                    <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0 select-none">
                      {activeSubText}
                    </dd>
                    </div>
                    
                    {
                      activeSub ?  
                        <div>      
                          <button
                          type="button"
                          className="rounded-md bg-red px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                          disabled  = {disableUnsub}
                          onClick={handleUnsub}
                        >
                          {
                            disableUnsub ?             
                              <div className="flex m-1 pl-3 pr-3">
                              {" "}
                              <BeatLoader color="#f5f2ff" size={5} />{" "}
                            </div>
                            :
                            "Unsubscribe"
                          }
                        </button>
                      </div>
                    : 
                      null
                    }

                  </div>
                </div>
              </dl>
            </div>
          </div>
    </div>
    </>
  );
};


export default withAuthenticator(Account, { hideSignUp: true });